
import React from 'react';
import { CalendarDays, Clock, MapPin } from 'lucide-react';

const EventDetails = () => {
  return (
    <div className="bg-white p-6 rounded-xl shadow-lg">
      <h2 className="text-2xl md:text-3xl font-semibold text-center mb-6">Webinar Details</h2>
      
      <div className="space-y-4">
        <div className="flex items-center">
          <CalendarDays className="h-6 w-6 text-blue-500 mr-3" />
          <div>
            <p className="text-sm text-gray-500 font-medium">Date</p>
            <p className="text-lg">Thursday, 29th May 2025</p>
          </div>
        </div>
        
        <div className="flex items-center">
          <Clock className="h-6 w-6 text-blue-500 mr-3" />
          <div>
            <p className="text-sm text-gray-500 font-medium">Time</p>
            <p className="text-lg">3:00 PM - 4:00 PM BST (British Summer Time)</p>
            <p className="text-sm text-gray-600">(60 minutes, exclusively for parents in the UK)</p>
          </div>
        </div>
        
        <div className="flex items-center">
          <MapPin className="h-6 w-6 text-blue-500 mr-3" />
          <div>
            <p className="text-sm text-gray-500 font-medium">Location</p>
            <p className="text-lg">Live on Zoom (Link After Registration)</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventDetails;
